<template>
    <div>
        <nav class="level mb-2 py-2">
            <div class="level-left">
                <div class="level-item">
                    <p class="menu-label pl-3">
                        {{ title }}
                    </p>
                </div>
            </div>
            <div class="level-right">
                <a
                    v-if="isAdmin"
                    v-t="'Buttons.add'"
                    class="menu-label has-text-primary has-text-weight-bold"
                    @click="$emit('create')"
                />
            </div>
        </nav>
        <draggable
            :list="items"
            :disabled="!isAdmin"
            @end="$emit('sort', $event)"
        >
            <div v-for="item in items" :key="item._id">
                <li
                    class="is-capitalized-first has-text-weight-bold is-size-6 mb-1 pb-1"
                >
                    <div class="level is-mobile">
                        <div class="level-left is-shrinkable">
                            <div class="level-item is-shrinkable">
                                <router-link
                                    :class="{
                                        'is-active':
                                            linkParams.routeName == 'folder'
                                                ? $store.state.activeFolder ==
                                                  item._id
                                                : false,
                                    }"
                                    :to="{
                                        name: linkParams.routeName,
                                        params: { id: item._id },
                                    }"
                                >
                                    {{ item.name || item.title }}
                                </router-link>
                                <p
                                    v-if="item.badgeCount"
                                    class="is-relative lb-margin-badge"
                                >
                                    <span
                                        class="badge is-size-7 has-background-pink-red"
                                        >{{ item.badgeCount }}</span
                                    >
                                </p>
                            </div>
                        </div>
                        <div class="level-right">
                            <div
                                v-if="isAdmin"
                                class="level-item"
                                @click.stop.prevent
                            >
                                <div
                                    class="dropdown is-right is-hoverable is-pulled-right"
                                >
                                    <span
                                        class="icon is-small dropdown-trigger has-text-grey mt-1"
                                    >
                                        <i
                                            class="mdi mdi-24px mdi-dots-vertical"
                                            aria-hidden="true"
                                        />
                                    </span>
                                    <div class="dropdown-menu" role="menu">
                                        <div class="dropdown-content">
                                            <a
                                                v-t="
                                                    'Folders.dropdown_option_edit'
                                                "
                                                class="dropdown-item"
                                                @click.stop.prevent="
                                                    $emit('editItem', item)
                                                "
                                            />
                                            <a
                                                v-t="
                                                    'Folders.dropdown_option_delete'
                                                "
                                                class="dropdown-item"
                                                @click.stop.prevent="
                                                    $emit('deleteItem', item)
                                                "
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </li>
            </div>
        </draggable>
    </div>
</template>

<script>
import draggable from 'vuedraggable';

export default {
    components: {
        draggable,
    },
    props: {
        items: {
            type: Array,
            required: true,
        },
        title: {
            type: String,
            required: true,
        },
        isAdmin: {
            type: Boolean,
            default: false,
        },
        linkParams: {
            type: Object,
            default: () => {},
        },
    },
};
</script>

<style scoped>
.lb-margin-badge {
    margin-left: -5px;
    margin-top: -10px;
}
</style>
